import React, { useEffect, useState, useLayoutEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../GlobalVars';
import {
  saveAccessToken,
  saveRefreshToken,
  shouldPreserveTokens,
} from '../../Redux/Tokens';
import { RootState } from '../../Redux/store';

import Dashboard from '../Dashboard';
import Landing from '../Landing';

import AppIdle from './AppIdle';
import RefreshModal from '../RefreshModal';

import {
  Parallax,
  ParallaxProvider,
  useController,
} from 'react-scroll-parallax';

import {
  AppWrapper,
  GlobalStyle,
  BgWrapper,
  Background,
  Foreground,
  Earth,
  Overlay,
} from './App.styled';

function mapStateToProps(state: RootState) {
  const { accessToken } = state.tokens;
  return { accessToken };
}

const connector = connect(mapStateToProps, {
  _saveAccessToken: saveAccessToken,
  _saveRefreshToken: saveRefreshToken,
  _shouldPreserveTokens: shouldPreserveTokens,
});

type AppProps = ConnectedProps<typeof connector>;

function ChangeListener(): null {
  const { parallaxController } = useController();

  useLayoutEffect(() => {
    function updateController() {
      parallaxController.update();
    }
    window.addEventListener('resize', updateController);
    return () => window.removeEventListener('resize', updateController);
  });

  return null;
}

function App({
  _saveAccessToken,
  _saveRefreshToken,
  _shouldPreserveTokens,
  accessToken,
}: AppProps): React.ReactElement {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const isLocal = localStorage.getItem(ACCESS_TOKEN) || false;

    let accessToken = null;
    let refreshToken = null;

    if (isLocal) {
      accessToken = localStorage.getItem(ACCESS_TOKEN);
      refreshToken = localStorage.getItem(REFRESH_TOKEN);
    } else {
      accessToken = sessionStorage.getItem(ACCESS_TOKEN);
      refreshToken = sessionStorage.getItem(REFRESH_TOKEN);
    }

    _shouldPreserveTokens(isLocal ? 'true' : 'false');
    _saveAccessToken(accessToken);
    _saveRefreshToken(refreshToken);
    setMounted(true);
  }, [_saveAccessToken, _saveRefreshToken, _shouldPreserveTokens]);

  return (
    <ParallaxProvider>
      <ChangeListener />
      <AppWrapper className="app-wrapper">
        <BgWrapper className="bg-wrapper">
          <Background />
          <Parallax y={[-40, 40]} className="earth-wrapper">
            <Earth />
          </Parallax>
          <Foreground />
          <Overlay />
        </BgWrapper>
        <Router>
          <AppIdle />
          <GlobalStyle />
          <RefreshModal />
          {mounted ? accessToken ? <Dashboard /> : <Landing /> : ''}
        </Router>
      </AppWrapper>
    </ParallaxProvider>
  );
}

export default connector(App);
